export enum StatusExtracaoEnum
{
    AguardandoProcessamento = 1,
    EmProcessamento = 2,
    ProcessadoComSucesso = 3,
    ProcessadoComErro = 4
}